import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { switchMap, debounceTime, tap, finalize } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { UserService } from '../../../services/user.service';
import { ScrapService } from '../../../services/scrap.service';

export interface List {
  value: string;
  name: string;
}

@Component({
  selector: 'app-filter-scraps',
  templateUrl: './filter-scraps.component.html',
  styleUrls: ['./filter-scraps.component.css'],
  providers: [UserService, ScrapService]
})
export class FilterScrapsComponent implements OnInit {

  usersForm: FormGroup;
  public myControl = new FormControl();
  public x: any;

  public nuevo = false;
  public loading = false;
  public options: Observable<List[]>;
  list: List[] = [];
  public token;

  @Output() select: EventEmitter<any>;

  public nuevoScrap = {
    value: 'new',
    name: 'New Scrap'
  };

  constructor(
    private _userService: UserService,
    private _scrapService: ScrapService,
    private fb: FormBuilder,) {
    this.select = new EventEmitter;
    this.token = this._userService.getToken();
  }

  ngOnInit() {

    this.usersForm = this.fb.group({
      userInput: null
    });

    this.options = this.myControl.valueChanges.pipe(
      startWith<string | List>(''),
      map(value => typeof value === 'string' ? value : value.name),
      map(name => name ? this._filterClientes(name) : this.list.slice())
    );

    this.loading = true;
    this._scrapService.getAll(this.token, 'CLOSED').subscribe(
      response => {
        console.log(response);
        if (response.status === 'success') {
          // this.pacientes = response.data;

          response.data.forEach(function (element) {
            if (element.companyLinked === null) {

            } else {
              this.list.push(
                {
                  value: element.id,
                  name: element.id + ' - ' + element.categoryId.name + ' - ' +
                    (Number(element.grossWeight) - Number(element.tareWeight)) + ' lbs'
                }
              );
            }

          }.bind(this));
        }
        this.loading = false;
      },
      error => {
        console.log(<any>error);
        this.loading = false;
      }
    );
  }

  private _filterClientes(name: string): List[] {
    const filterValue = name.toLowerCase();
    return this.list.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  displayFn(option?: List): string | undefined {
    return option ? option.name : undefined;
  }

  OnHumanSelected(option) {
    console.log(option);

   if (option.value.value === 'new') {
    // this.nuevoMasterItem();
   } else {
    this.select.emit(option.value);
   }
  }

}
